import React from "react";

import { Container } from "react-bootstrap";
import Component_1 from "../tabs_common_components/component_1/Component_1";
import Component_2 from "../tabs_common_components/component_2/Component_2";
import Component_3 from "../tabs_common_components/component_3/Component_3";
import Component_4 from "../tabs_common_components/component-4/Component_4";
import Component_5 from "../tabs_common_components/component_5/Component_5";

const Marathon = () => {
  const focusData = [
    {
      id: 1,
      icon: "/assets/images/sports-program/component-3/strength.png",
      title: "Strength",
      description:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed non risus. Suspendisse lectus.",
    },
    {
      id: 2,
      icon: "/assets/images/sports-program/component-3/endurance.png",
      title: "Endurance",
      description:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed non risus. Suspendisse lectus.",
    },
    {
      id: 3,
      icon: "/assets/images/sports-program/component-3/flexibility.png",
      title: "Flexibility",
      description:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed non risus. Suspendisse lectus.",
    },
    {
      id: 4,
      icon: "/assets/images/sports-program/component-3/speed-agility.png",
      title: "Speed",
      description:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed non risus. Suspendisse lectus.",
    },
    {
      id: 5,
      icon: "/assets/images/sports-program/component-3/core-stability.png",
      title: "Core Stability",
      description:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed non risus. Suspendisse lectus.",
    },
    {
      id: 6,
      icon: "/assets/images/sports-program/component-3/fat-loss.png",
      title: "Fat Loss",
      description:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed non risus. Suspendisse lectus.",
    },
    {
      id: 7,
      icon: "/assets/images/sports-program/component-3/pace-setting.png",
      title: "Pace Setting",
      description:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed non risus. Suspendisse lectus.",
    },
    {
      id: 8,
      icon: "/assets/images/sports-program/component-3/meditation.png",
      title: "Meditation & Mental Stability",
      description:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed non risus. Suspendisse lectus.",
    },
  ];
  return (
    <section className="marathon_section">
      <Container>
        <Component_1
          topDescn={
            "Our Marathon Training Program is designed for runners of all levels—whether you are preparing for your first race or aiming to improve your personal best. With structured plans, expert guidance, and consistent support, we help you build endurance, strength, and confidence to complete your marathon successfully."
          }
          title={"Key Phases of Marathon Training"}
          features={[
            {
              label: "Base Building (8–12 Weeks)::",
              value:
                "Focus on consistency and running volume with easy, conversational-paced runs to develop cardiovascular fitness and endurance.",
            },
            {
              label: "Strength & Speed (4–6 Weeks):",
              value:
                "Incorporate challenging sessions like interval training and tempo runs to improve running efficiency, strength, and race pace.",
            },
            {
              label: "Peak Phase (2–4 Weeks):",
              value:
                "Push endurance limits with your longest runs — peaking around 30–32 km (20 miles) — three to four weeks before race day.",
            },
            {
              label: "Tapering (2–3 Weeks):",
              value:
                "Gradually reduce mileage to rest, recover, and store energy for your best performance on race day.",
            },
          ]}
          imgSrc="./assets/images/sports-program/component-1/marathon.png"
        />

        <div className="our_goal">
          <div className="head">Our Goal</div>
          <p className="text">
            To prepare runners physically and mentally for marathon events
            through scientifically designed training and proper guidance.
          </p>
        </div>
        <Component_5
          title={"Benefits of Marathon Training"}
          features={[
            "Builds strong endurance and stamina",
            "Improves cardiovascular fitness",
            "Enhances mental strength and discipline",
            "Helps in weight management",
            "Boosts confidence and achievement mindset",
          ]}
        />

        <Component_1
          topDescn={""}
          title={"Workout Plan"}
          features={[
            {
              label: "10 min:",
              value: "Warm-up & mobility exercises (10 min) ",
            },
            {
              label: " ",
              value: "Daily separate workout ",
            },
            {
              label: "",
              value: "  Long run ",
            },
            {
              label: "",
              value: " short sprint ",
            },
            {
              label: "",
              value: "   pace running  ",
            },
            {
              label: "",
              value: " Strength training  ",
            },
            {
              label: "",
              value: " weight training   ",
            },
            {
              label: "",
              value: " functional Training  ",
            },
            {
              label: "",
              value: "core training    ",
            },
            {
              label: "",
              value: " recovery  ",
            },

            {
              label: "10 min",
              value: "    Stretching ",
            },
          ]}
        />

        <Component_2
          title={"Weekly Training Components"}
          imgSrc="./assets/images/sports-program/component-2/run.png"
          features={[
            {
              label: "Runs:   ",
              value: "3–4 weekly runs focusing on endurance and form.",
              imgSrc: "./assets/images/sports-program/component-2/run.png",
            },
            {
              label: "Long Runs:  ",
              value:
                "One weekly long run that increases in distance each week. Run at a steady, comfortable pace.",
              imgSrc: "./assets/images/sports-program/component-2/long-run.png",
            },
            {
              label: "Easy Runs:",
              value:
                "Short, low-intensity runs for recovery and aerobic conditioning.",
              imgSrc: "./assets/images/sports-program/component-2/easy-run.png",
            },
            {
              label: "Speed Work:",
              value:
                "Includes tempo runs, intervals, and hill sprints to boost speed and stamina.",
              imgSrc:
                "./assets/images/sports-program/component-2/speed-work.png",
            },
            {
              label: "Cross-Training: ",
              value:
                " 1–2 low-impact sessions like swimming or cycling to build strength and reduce injury risk.",
              imgSrc:
                "./assets/images/sports-program/component-2/cross-training.png",
            },
            {
              label: "Strength Training:",
              value:
                " Focus on legs and core with exercises like squats, lunges, and deadlifts for better running power.",
              imgSrc: "./assets/images/sports-program/component-2/strength.png",
            },
            {
              label: "Rest:",
              value:
                "Rest is essential for muscle recovery and injury prevention — never skip it.",
              imgSrc: "./assets/images/sports-program/component-2/rest.png",
            },
          ]}
        />

        <Component_5
          title={"What We Offer"}
          features={[
            "Structured marathon training plans (5K, 10K, Half & Full Marathon)",
            "Endurance and long-distance running sessions",
            "Speed workouts & interval training",
            "Strength & conditioning exercises",
            "Recovery and stretching sessions",
            "Running technique improvement",
            "Race strategy and pacing guidance",
          ]}
        />

        <Component_4 />

        <Component_3 focusData={focusData} />
      </Container>
    </section>
  );
};
export default Marathon;
